<template>
    <crud-list :data-list="categories">
      <template v-slot:listItem="{ listItem }">
        {{ listItem.name }}
      </template>
      <template  v-slot="{ form: item }">
        <form-category :toCopy="item.item" :operation="item.operation"/>
      </template>
    </crud-list>
</template>

<script>
import FormCategory from "@/modules/category/components/FormCategory";
import { mapState, mapActions } from "vuex";
import CrudList from "@/core/components/CrudList";

export default {
  name: 'Category',
  components:{
    FormCategory,
    CrudList
  },
  computed: {
    ...mapState('categories', ['categories'])
  },
  created() {
    this.loadCategories()
  },
  updated() {
    this.loadList(this.categories)
  },
  methods: {
    ...mapActions('categories', ['loadCategories']),
    ...mapActions('crudList',['loadList'])
  },
}
</script>
